// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpOptionCategoryProps = {
    label: string;
    level: string;
};

export const WebpOptionCategory: FunctionComponent<WebpOptionCategoryProps> = ({ label, level }) => {
    return <Container className={`level-${level}`}>{label}</Container>;
};
